<template>
  <Layout>
    <div id="evMap">

      <div class="spinner-area" v-if="isLoading">
        <b-spinner variant="main-green" style="width: 2.5rem; height: 2.5rem;" role="status" />
      </div>

      <!-- START Road View Area -->
      <div id="rvWrapper">
        <div id="roadView" class="w-100 h-100" />
        <div id="close" title="닫기" @click="closeRoadView()"><span class="img" /></div>
      </div>
      <!-- END Road View Area -->

      <!-- START Map Area -->
      <div id="mapWrapper">
        <!-- START Kakao Map -->
        <KakaoMap ref="kakaoMap" class="w-100 h-100" :options="initMapOptions" @checkInstance="checkInstance"/>
        <!-- END Kakao Map -->

        <div class="search-area">

          <!-- START Search Box -->
          <div class="search-box-area">
            <div class="input-group">
              <input type="text" class="form-control" id="inputGroupSearchText" placeholder="Search"
                     v-model="searchStationSimpleKeyword" autocomplete="off" @keyup.enter="searchStation('simple')" />
              <button class="keyword-delete-btn" :style="searchStationSimpleKeyword ? 'display: block' : 'display: none'"
                      @click="searchStationSimpleKeyword = null">
                <i class="mdi mdi-close align-text-top"/>
              </button>
              <label class="search-btn-label" for="inputGroupSearchText" @click="searchStation('simple')">
                <i class="bx bx-search-alt" />
                <span>충전소</span>
              </label>
            </div>
          </div>
          <!-- END Search Box -->

          <button class="road-search-btn" @click="searchRoadFromHere">
            <i class="mdi mdi-car-arrow-right" />
            <span>경로 안내</span>
          </button>
        </div>

        <!-- START Map Type Button -->
<!--        <div class="map-type-btn-area">-->
<!--          <div class="map-type-btn-group">-->
<!--            <span :class="mapType === 'roadMap' ? 'selected-btn' : 'unselected-btn'" @click="changeMapType('roadMap')">일반</span>-->
<!--            <span :class="mapType === 'skyView' ? 'selected-btn' : 'unselected-btn'" @click="changeMapType('skyView')">위성</span>-->
<!--          </div>-->
<!--        </div>-->
        <!-- END Map Type Button -->

        <!-- START Road View Button -->
        <div id="roadViewControl" @click="setRoadView()" />
        <!-- END Road View Button -->

        <!-- START Traffic Button -->
<!--        <div id="trafficBtnArea" @click="setTraffic()">-->
<!--          <i class="fa fa-traffic-light fa-lg" />-->
<!--        </div>-->
        <!-- END Traffic Button -->

        <!-- START Icon Info -->
        <div class="icon-info-area">
          <div :class="{'m-right': i !== iconInfoOptions.length-1}" v-for="(option, i) in iconInfoOptions" :key="i">
            <img :alt="`${option.label}`" :src="require(`@/assets/images/map/status/${option.icon}.png`)" />
            <span class="ct-padding-left-25">{{ option.label }}</span>
          </div>
        </div>
        <!-- END Icon Info -->

        <!-- START Marker Type Button -->
<!--        <div class="marker-type-btn-area">
          <div class="marker-type-btn-group">
            <div :class="markerType === 'chargerCount' ? 'selected-btn' : 'unselected-btn'" @click="changeMarkerType('chargerCount')">
              <i class="bx bxs-map status-icon"/>
            </div>
            <div :class="markerType === 'chargePrice' ? 'selected-btn' : 'unselected-btn'" @click="changeMarkerType('chargePrice')">
              <i class="mdi mdi-currency-krw price-icon"/>
            </div>
          </div>
        </div>-->
        <!-- END Marker Type Button -->

        <!-- START Current Location Button -->
        <div id="currentLocationBtn" @click="getGeoAroundItems('cur')" />
        <!-- END Current Location Button -->

        <!-- START Charger Speed Button -->
        <div class="charger-speed-btn-area" v-if="$_utils.isEmpty(stationResult.stationList)">
          <div class="charger-speed-btn-group" v-for="(item, index) in chargerSpeedOptions" :key="index">
            <span :class="searchStationOptions.chargerSpeed === `${item.value}` ? `${item.value}-selected-btn` : 'unselected-btn'"
                  @click="changeChargerSpeed(item.value)">{{ item.label }}</span>
            <br v-if="index !== chargerSpeedOptions.length-1" />
          </div>
        </div>
        <!-- END Charger Speed Button -->

        <!-- START Search Sidebar -->
        <div id="searchSidebar" class="search-sidebar shadow">
          <div class="p-2">
            <!-- START Sidebar Header -->
            <div class="row search-sidebar-header align-items-center justify-content-between">
              <div class="col-auto font-size-15">
                {{ isStationSearchMode ? '충전소 찾기' : '길찾기' }}
              </div>
              <div class="col-auto text-end">
                <i class="mdi mdi-arrow-left-circle-outline close-btn" @click="searchSideBar(false)" />
              </div>
            </div>
            <!-- END Sidebar Header -->

            <!-- START Search Station Content Area -->
            <template v-if="isStationSearchMode">
              <ev-station :search-keyword="searchStationSimpleKeyword"
                          :result="stationResult"
                          :station-page="stationPage"
                          :kakao-page="kakaoPage"
                          @onPageChange="onPageChange"
                          @changeChargerSpeed="changeChargerSpeed"
                          @searchStation="searchStation"
                          @showOnMap="showOnMap"
                          @reset="reset" />
            </template>
            <!-- END Search Station Content Area -->

            <!-- START Search Road Content Area -->
            <template v-else>
              <ev-road ref="evMapRoad"
                       :current-location="currentLocation"
                       :search-keyword="searchStationSimpleKeyword"
                       :around-stations="aroundStations"
                       @changeChargerSpeed="changeChargerSpeed"
                       @reset="reset"
                       @showOnMap="showOnMap"
                       @drawRoad="drawRoad" />
            </template>
            <!-- END Search Road Content Area -->
          </div>
        </div>
        <!-- END Search Sidebar -->
      </div>
      <!-- END Map Area -->

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import KakaoMap from '@/views/pages/maps/kakaoMap.vue';
import Multiselect from 'vue-multiselect';

import EvRoad from '@/views/pages/maps/evMapRoad.vue';
import imageSrc from "@/assets/images/map/start_point.png";
import axios from "axios";
import SearchButtons from "@/views/components/searchButtons.vue";
import EvStation from "@/views/pages/maps/evMapStation.vue";
import { http } from "@/mdk/auth-api";

export default {
  components: { SearchButtons, Layout, KakaoMap, Multiselect, EvRoad, EvStation },
  data() {
    return {
      isLoading: true,
      currentLocation: { // 사용자 현위치
        tempGeo: true,
        lat: null,
        lng: null
      },
      initMapOptions: { // 지도 중심좌표
        lat: null, // 37.498204,    // 위도 (I-ON)
        lng: null, // 127.032685,   // 경도 (I-ON)
        level: 4
      },
      mapInstance: null,
      mapType: 'roadMap',
      markerType: 'chargerCount',
      roadViewMarker: [],
      roadViewOverlayOn: false,
      trafficOverlayOn: false,
      iconInfoOptions: [
        { label: '충전 가능', icon: 'possible' },
        { label: '충전중', icon: 'charging' },
        { label: '고장/점검', icon: 'broken' },
        { label: '상태 미확인', icon: 'unconfirmed' }
      ],
      chargerSpeedOptions: [
        { label: '전체', value: 'all' },
        { label: '완속', value: 'ac' },
        { label: '급속', value: 'dc' }
      ],
      isStationSearchMode: true,   // true: 충전소 찾기, false: 길 찾기
      searchStationSimpleKeyword: null,
      searchStationDist: 2,   // 현재 좌표 반경 (Km)
      searchStationResultLimit: 150,   // 검색 건수
      searchStationOptions: {
        keyword: null,
        chargerSpeed: 'all',
        address1: { value: 'all', text: '시/도 (전체)' },
        address2: { value: 'all', text: '시/군/구 (전체)' },
        agency: { value: 'all', text: '운영 기관 (전체)' },
        isUnlimited: true,
        isParkingFree: true,
        // kind: { value: 'all', text: '시설 유형 (전체)' },
        chargerType: ['01', '02', '04', '07']
      },
      stationResult: {
        req: null,  // search(충전소 조회), around(주변 장소), road(길 찾기)
        station: [],
        stationList: [],
        kakaoList: []
      },
      stationPage: {
        currentPage: 1,
        totalCount: 0,
        perPage: 100
      },
      kakaoPage: {
        current: 1,
        totalCount: 0,
        perPage: 15
      },
      stationMarkers: [],
      mapBounds: [],
      selectMarker: [],   // 선택한 Marker
      searchMarkers: {
        startPoint: null,
        endPoint: null
      },
      polylines: [],
      aroundStations: null
    }
  },
  created() {
    const vm = this;

    vm.getGeoAroundItems('init');


  },
  mounted() {
    const vm = this;

    // Style (Layout)
    document.getElementsByClassName('page-content')[0].style.padding = 0;
    document.getElementsByClassName('container-fluid')[0].style.padding = 0;

    // Check Mobile
    if (window.matchMedia('(max-width: 992px)').matches) {
      document.getElementById('evMap').style.height = window.innerHeight + 'px';
    }
  },
  methods: {
    checkInstance(mapInstance) {
      const vm = this;
      vm.mapInstance = mapInstance;
      if (vm.mapInstance) {
        vm.pageInit();
        // vm.getItems();
      }
    },
    getGeoAroundItems(type) {
      const vm = this;

      vm.getGeolocation(type)
        .then(res => vm.getItems())
    },
    async getGeolocation(type) {
      const vm = this;

      // Geolocation 사용 (https 또는 localhost 에서만 사용 가능, http 사용 불가능)
      if (location.protocol.indexOf('https')>-1 || location.host.indexOf('localhost')>-1) {
        let textContent = 'Locating...';

        if (type === 'init') {
          //첫 페이지 집입 시 I-ON으로 위치 고정
          vm.currentLocation = {
            tempGeo: true,
            lat: 37.498204,
            lng: 127.032685,
          };

          vm.initMapOptions = {
            lat: 37.498204,
            lng: 127.032685,
          };
        } else {
          if (!('geolocation' in navigator)) {
            textContent = 'Geolocation is not available !!';
            console.log(textContent);
          } else {
            console.log(textContent);

            const getPosition = () => {
              return new Promise((resolve, rejected) => {
                navigator.geolocation.getCurrentPosition(resolve, rejected, {
                  enableHighAccuracy: true,
                  timeout: 5000,
                  maximumAge: 0
                })
              });
            };

            try {
              const pos = await getPosition();

              vm.currentLocation = {
                tempGeo: false,
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
              };

              vm.initMapOptions = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
              };


              console.log('Current Location [ 위도: ' + pos.coords.latitude + ', 경도: ' + pos.coords.longitude + ' ]')

            } catch (err) {
              console.log('Geolocation Error :: ', err.message);
              console.log('Geolocation Error Code :: ', err.code);

              // (I-ON 위치로 설정)
              vm.currentLocation = {
                tempGeo: true,
                lat: 37.498204,
                lng: 127.032685,
              };

              vm.initMapOptions = {
                lat: 37.498204,
                lng: 127.032685,
              };

              if (type !== 'init') {
                this.$swal(this.$_map_data.getGeolocationError(err.code), '', 'error');
              }
            }
          }


        }

      } else {
        this.$swal('HTTP 환경에서는 사용 불가 !!', '' , 'error');
      }
    },
    async getItems() {
      const vm = this;

      try {
        const _url = `/me/station/around`;

        //const limitYn = vm.searchStationOptions.isUnlimited === true ? 'N' : 'Y';  // N:제한 없음
        //const parkingFree = vm.searchStationOptions.isParkingFree === true ? 'Y' : 'N';  // Y:무료
        //const ticker = vm.markerType === 'chargerCount' ? 1 : 2;

        const _params = {
          lng: vm.initMapOptions.lng,
          lat: vm.initMapOptions.lat ,
          // dist: vm.searchStationDist,
          // pageSize: 100,
          //speed: vm.searchStationOptions.chargerSpeed,
          //limit: limitYn,
          //parking: parkingFree,
          //ticker: ticker
        }
        const res = await this.$axios.get(_url, { params: _params });

        vm.stationResult.station = res.data;
        vm.stationResult.req = 'around';
        vm.displayMarker();

      } catch (error) {
        console.error(error);
      }
      vm.isLoading = false;
      // }
    },
    async displayMarker() {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;


      if (this.$refs.kakaoMap.clusterer) {
        // Clusterer 초기화
        this.$refs.kakaoMap.clusterer.clear();

        // Marker 초기화
        vm.removeMarker(vm.stationMarkers);
        vm.stationMarkers = [];

        // 지도 범위를 재설정할 범위 정보
        vm.mapBounds = new window.kakao.maps.LatLngBounds();
        await (vm.markerType === 'chargerCount' ? vm.showCountMarker() : vm.showPriceMarker());
      }

      vm.isLoading = false;
    },
    showCountMarker() {
      const vm = this;

      // Marker Size
      const iconWidth = 22;
      const iconHeight = 35;

      const coords = {
        shape: 'poly',
        coords: '10,0,5,1,1,5,0,10,0,15,10,34,12,34,22,15,22,7,17,1'
      };

      // 충전소 Marker
      const imageSrc = require('@/assets/images/map/status/unconfirmed.png');
      const imageSize = new window.kakao.maps.Size(iconWidth, iconHeight);
      const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, coords);

      if (vm.stationResult.req === 'road') {
        if (vm.aroundStations.length > 0) {
          vm.aroundStations.forEach((item) => {
            let _lat = item.location[1];
            let _lng = item.location[0];
            let _stationName = '';
            let _stationId = item.statId;

            let imageSrc2 = require(`@/assets/images/map/status/${item.map[0]}-${item.map[1]>99? 99:item.map[1]}.png`);
            let imageSize2 = new window.kakao.maps.Size(iconWidth, iconHeight);
            let markerImage2 = new window.kakao.maps.MarkerImage(imageSrc2, imageSize2, coords);

            let marker = new window.kakao.maps.Marker({
              position: new window.kakao.maps.LatLng(_lat, _lng),   // Marker 표시 위치
              title: _stationName,
              image: markerImage2,
              clickable: true
            });

            // window.kakao.maps.event.addListener(marker, 'click', () => vm.getStationInfo(_stationId));
            window.kakao.maps.event.addListener(marker, 'mouseover', () => marker.setZIndex(1));
            window.kakao.maps.event.addListener(marker, 'mouseout', () => marker.setZIndex(0));

            vm.mapBounds.extend(new window.kakao.maps.LatLng(_lat, _lng));
            vm.stationMarkers.push(marker);
          });

          this.$refs.kakaoMap.clusterer.addMarkers(vm.stationMarkers);

          if (vm.stationResult.req !== 'around') {
            vm.mapInstance.setBounds(vm.mapBounds);
          }
        }
      } else {
        if (vm.stationResult.station.length>0) {
          vm.stationResult.station.forEach((item) => {
            //const _lat = item.location[1];
            //const _lng = item.location[0];
            const _lat = item.lat;
            const _lng = item.lng;
            const _stationName = item.statNm;
            const _stationId = item.statId;

            const marker = new window.kakao.maps.Marker({
              position: new window.kakao.maps.LatLng(_lat, _lng),   // Marker 표시 위치
              title: _stationName,
              image: markerImage,
              clickable: true
            });

            // 충전소 상태 Marker
            const imageStatusSrc = require(`@/assets/images/map/status/${item.map[0]}-${item.map[1]>99? 99:item.map[1]}.png`);
            const imageStatusSize = new window.kakao.maps.Size(iconWidth, iconHeight);
            const markerStatusImage = new window.kakao.maps.MarkerImage(imageStatusSrc, imageStatusSize, coords);

            marker.setImage(markerStatusImage);

            window.kakao.maps.event.addListener(marker, 'click', () => vm.getStationInfo(_stationId));
            window.kakao.maps.event.addListener(marker, 'mouseover', () => marker.setZIndex(1));
            window.kakao.maps.event.addListener(marker, 'mouseout', () => marker.setZIndex(0));

            vm.mapBounds.extend(new window.kakao.maps.LatLng(_lat, _lng));
            vm.stationMarkers.push(marker);
          });

          this.$refs.kakaoMap.clusterer.addMarkers(vm.stationMarkers);

          if (vm.stationResult.req !== 'around') {
            vm.mapInstance.setBounds(vm.mapBounds);
          }
        }
      }
    },
    async showPriceMarker() {
      const vm = this;

      if (vm.stationResult.req === 'road') {
        if (vm.aroundStations.length > 0) {
          vm.aroundStations.map(item => {
            const _lat = Array.isArray(item.location) ? item.location[1] : item.location.lat;
            const _lng = Array.isArray(item.location) ? item.location[0] : item.location.lon;
            let _stationName = '';
            let _stationId = item.statId;
            let _chargePrice = item.price;

            // 가격 overlay element 생성
            const content = document.createElement('div');
            switch (true) {
              case _chargePrice >= 500 : content.className = 'bubble-overlay-500'; break;
              case _chargePrice >= 400 : content.className = 'bubble-overlay-400'; break;
              case _chargePrice >= 300: content.className = 'bubble-overlay-300'; break;
              case _chargePrice >= 200: content.className = 'bubble-overlay-200'; break;
              case _chargePrice >= 100: content.className = 'bubble-overlay-100'; break;
              default: content.className = 'bubble-overlay-default';
            };
            content.innerText = `${_chargePrice}`;
            // content.onclick = () => vm.getStationInfo(_stationId);

            const customOverlay = new window.kakao.maps.CustomOverlay({
              position: new window.kakao.maps.LatLng(_lat, _lng),   // Marker 표시 위치
              content: content,
              xAnchor: 0.5,
              yAnchor: 1.3,
              clickable: true,
            });

            customOverlay.setMap(vm.mapInstance);

            content.onmouseover = () => customOverlay.setZIndex(1);
            content.onmouseout = () => customOverlay.setZIndex(0);

            vm.mapBounds.extend(new window.kakao.maps.LatLng(_lat, _lng));
            vm.stationMarkers.push(customOverlay);
          })

          this.$refs.kakaoMap.clusterer.addMarkers(vm.stationMarkers);

          if (vm.stationResult.req !== 'around') {
            vm.mapInstance.setBounds(vm.mapBounds);
          }
        }
      } else {
        if (vm.stationResult.station.length > 0) {
          vm.stationResult.station.map(async (item) => {
            const _lat = Array.isArray(item.location) ? item.location[1] : item.location.lat;
            const _lng = Array.isArray(item.location) ? item.location[0] : item.location.lon;
            const _stationId = item.statId;
            const _chargePrice = item.price;

            // 가격 overlay element 생성
            const content = document.createElement('div');
            switch (true) {
              case _chargePrice >= 500 : content.className = 'bubble-overlay-500'; break;
              case _chargePrice >= 400 : content.className = 'bubble-overlay-400'; break;
              case _chargePrice >= 300: content.className = 'bubble-overlay-300'; break;
              case _chargePrice >= 200: content.className = 'bubble-overlay-200'; break;
              case _chargePrice >= 100: content.className = 'bubble-overlay-100'; break;
              default: content.className = 'bubble-overlay-default';
            };
            content.innerText = `${_chargePrice}`;
            content.onclick = () => vm.getStationInfo(_stationId);

            const customOverlay = new window.kakao.maps.CustomOverlay({
              position: new window.kakao.maps.LatLng(_lat, _lng),   // Marker 표시 위치
              content: content,
              xAnchor: 0.5,
              yAnchor: 1.3,
              clickable: true,
            });

            customOverlay.setMap(vm.mapInstance);

            content.onmouseover = () => customOverlay.setZIndex(1);
            content.onmouseout = () => customOverlay.setZIndex(0);

            vm.mapBounds.extend(new window.kakao.maps.LatLng(_lat, _lng));
            vm.stationMarkers.push(customOverlay);
          });

          this.$refs.kakaoMap.clusterer.addMarkers(vm.stationMarkers);

          if (vm.stationResult.req !== 'around') {
            vm.mapInstance.setBounds(vm.mapBounds);
          }
        }
      }
    },
    pageLoading() {
      const vm = this;

      if (vm.mapInstance) {
        clearInterval(this.loading);
        vm.pageInit();
      }
    },
    pageInit() {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      // Mouse Dragged Event
      window.kakao.maps.event.addListener(vm.mapInstance, 'dragend', () => {
        const latlng = vm.mapInstance.getCenter();

        vm.initMapOptions.lat = latlng.getLat();
        vm.initMapOptions.lng = latlng.getLng();
        console.log('변경된 지도 중심 좌표 [ 위도: ' + latlng.getLat() + ', 경도: ' + latlng.getLng() + ' ]')

        if (vm.stationResult.req === 'around') {
          vm.getItems();
        }
      })

      // Mouse Click Event (Road View)
      window.kakao.maps.event.addListener(vm.mapInstance, 'click', (mouseEvent) => {
        if (vm.roadViewOverlayOn) {
          const position = mouseEvent.latLng;
          vm.roadViewMarker[0].setPosition(position);

          vm.toggleRoadView(position);
        }
      });
    },
    changeMarkerType(type) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      vm.markerType = type === 'chargerCount' ? 'chargerCount' : 'chargePrice' ;

      if (vm.stationResult.req === 'search') {
        vm.searchStation();
      } else if (vm.stationResult.req === 'road') {
        this.$refs.evMapRoad.searchRoad();
      } else {
        vm.getItems();
      }
    },
    changeMapType(type) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      if (type === 'roadMap') {
        vm.mapInstance.setMapTypeId(window.kakao.maps.MapTypeId.ROADMAP);
        vm.mapType = 'roadMap';
      } else {
        vm.mapInstance.setMapTypeId(window.kakao.maps.MapTypeId.HYBRID);
        vm.mapType = 'skyView';
      }
    },
    changeChargerSpeed(type) {
      const vm = this;
      vm.searchStationOptions.chargerSpeed = type;

      if (this.$_utils.isEmpty(vm.stationResult.stationList)) {
        vm.getItems();
      }
    },
    setRoadView() {
      const vm = this;
      const control = document.getElementById('roadViewControl');

      if (control.className.indexOf('active')>-1) {
        control.className = '';
        vm.closeRoadView();
        vm.roadViewOverlay(false);
      } else {
        control.className = 'active';
        vm.roadViewOverlay(true);
      }
    },
    roadViewOverlay(active) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      const markImage = new window.kakao.maps.MarkerImage(
        'https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png',
        new window.kakao.maps.Size(26, 46),
        {
          spriteSize: new window.kakao.maps.Size(1666, 168),   // 스프라이트 이미지 전체 크기 지정
          spriteOrigin: new window.kakao.maps.Point(705, 114),   // 사용하고 싶은 영역의 좌상단 좌표
          offset: new window.kakao.maps.Point(13, 46)
        }
      );

      const marker = new window.kakao.maps.Marker({
        image: markImage,
        position: vm.mapInstance.getCenter(),
        draggable: true
      });

      vm.roadViewMarker.push(marker);

      // Marker Dragend Event
      window.kakao.maps.event.addListener(marker, 'dragend', (mouseEvent) => {
        const position = vm.roadViewMarker[0].getPosition();
        vm.toggleRoadView(position);
      });

      if (active) {
        vm.roadViewOverlayOn = true;

        vm.mapInstance.addOverlayMapTypeId(window.kakao.maps.MapTypeId.ROADVIEW);

        marker.setMap(vm.mapInstance);
        marker.setPosition(vm.mapInstance.getCenter());

        vm.toggleRoadView(vm.mapInstance.getCenter());
      } else {
        vm.roadViewOverlayOn = false;

        vm.mapInstance.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.ROADVIEW);

        vm.removeMarker(vm.roadViewMarker);
        vm.roadViewMarker = [];
      }
    },
    toggleRoadView(position) {
      const vm = this;

      const rvContainer = document.getElementById('roadView');
      const rv = new window.kakao.maps.Roadview(rvContainer);
      const rvClient = new window.kakao.maps.RoadviewClient();

      rvClient.getNearestPanoId(position, 50, (panoId) => {
        if (panoId === null) {
          vm.toggleMapWrapper(true, position);
        } else {
          vm.toggleMapWrapper(false, position);
          rv.setPanoId(panoId, position);
        }
      });

      // Road View 좌표가 바뀌었을 때 발생하는 이벤트
      window.kakao.maps.event.addListener(rv, 'position_changed', () => {
        const rvPosition = rv.getPosition();

        vm.initMapOptions.lat = rvPosition.Ma;
        vm.initMapOptions.lng = rvPosition.La;

        if (vm.roadViewOverlayOn) {   // Marker 위치를 현재 위치로 변경
          vm.roadViewMarker.forEach((m) => {
            m.setPosition(rvPosition);
          });
        }
      });
    },
    toggleMapWrapper(active, position) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;
      const container = document.getElementById('evMap');

      if (active) {
        container.className = '';
      } else {
        if (container.className.indexOf('view-roadview') === -1) {
          container.className = 'view-roadview';
        }
      }

      vm.mapInstance.relayout();
      vm.mapInstance.setCenter(position);
    },
    closeRoadView() {
      const vm = this;
      const position = vm.roadViewMarker[0].getPosition();
      vm.toggleMapWrapper(true, position);
    },
    setTraffic() {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;
      vm.trafficOverlayOn = !vm.trafficOverlayOn;

      const trafficBtnArea = document.getElementById('trafficBtnArea');
      trafficBtnArea.style.background = vm.trafficOverlayOn ? '#3396ff' : '#ffffff';
      trafficBtnArea.style.color = vm.trafficOverlayOn ? '#ffffff' : '';

      if (vm.trafficOverlayOn) {
        vm.mapInstance.addOverlayMapTypeId(window.kakao.maps.MapTypeId.TRAFFIC);
      } else {
        vm.mapInstance.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.TRAFFIC);
      }
    },
    reset() {
      const vm = this;

      vm.stationResult.station = vm.stationResult.stationList = [];
      vm.stationResult.req = null;
      vm.stationPage.totalCount = 0;

      vm.$nextTick(() => {
        vm.getItems();
      })
    },
    async searchStation(type, sidebarOptions) {
      const vm = this;

      if (type === 'simple' && vm.searchStationSimpleKeyword) {
        vm.stationPage.currentPage = 1;
        vm.kakaoPage.current = 1;
        vm.searchStationOptions.keyword = vm.searchStationSimpleKeyword;
        await Promise.all([
          // 충전소 검색
          vm.getStationItems(),

          // Kakao 주소 검색
          vm.getKakaoKeywordItems()
        ]);
      } else if (type === 'multi') {
        vm.stationPage.currentPage = 1;
        vm.kakaoPage.current = 1;
        vm.searchStationSimpleKeyword = sidebarOptions.keyword;
        vm.searchStationOptions = { ...vm.searchStationOptions, ...sidebarOptions }
        await Promise.all([
          // 충전소 검색
          vm.getStationItems(),

          // Kakao 주소 검색
          vm.getKakaoKeywordItems()
        ]);
      };

      vm.searchModeChange(true);
      vm.searchSideBar(true);

    },
    async getStationItems() {
      const vm = this;
      vm.isLoading = true;

      try {
        const _url = '/me/search/detail';

        const limitYn = vm.searchStationOptions.isUnlimited === true ? 'N' : 'Y';  // N:제한 없음
        const parkingFree = vm.searchStationOptions.isParkingFree === true ? 'Y' : 'N';  // Y:무료
        const ticker = vm.markerType === 'chargerCount' ? 1 : 2;

        const _params = {
          lon: vm.initMapOptions.lng,
          lat: vm.initMapOptions.lat,
          page: vm.stationPage.currentPage,
          speed: vm.searchStationOptions.chargerSpeed,
          limit: limitYn,
          parking: parkingFree,
          chgerType: vm.searchStationOptions.chargerType.reduce((acc, curr) => acc + curr, ''),
          ticker: ticker
        }

        if (!this.$_utils.isEmpty(vm.searchStationOptions.keyword)) {   // Keyword
          _params.statNm = vm.searchStationOptions.keyword;
        }

        // if (!this.$_utils.isEmpty(vm.searchStationOptions.address1) && vm.searchStationOptions.address1.value !== 'all') {   // 시/도
        //   _params.zcode = vm.searchStationOptions.address1.value;
        // }
        //
        // if (!this.$_utils.isEmpty(vm.searchStationOptions.address2) && vm.searchStationOptions.address2.value !== 'all') {   // 시/군/구
        //   _params.zscode = vm.searchStationOptions.address2.value;
        // }
        //
        // if (vm.searchStationOptions.agency.value !== 'all') {   // 운영 기관
        //   _params.busiId = vm.searchStationOptions.agency.value;
        // }

        // if (vm.searchStationOptions.kind.value !== 'all') {   // 시설 유형
        //   _params.kind = vm.searchStationOptions.kind.value;
        // }

        const res = await this.$axios.get(_url, { params: _params });

        vm.stationResult.station = vm.stationResult.stationList = res.data.items;
        vm.stationResult.req = 'search';
        vm.stationPage.totalCount = res.data.count;

        vm.displayMarker();

      } catch(err) {
        //this.$swal('충전소 데이터 조회 실패', '', 'error');
        console.error(err)
      }
    },
    getKakaoKeywordItems() {
      const vm = this;
      let searchWord = '';

      if (!this.$_utils.isEmpty(vm.searchStationOptions.keyword)) {   // Keyword
        searchWord += vm.searchStationOptions.keyword + ' ';
      }

      if (!this.$_utils.isEmpty(vm.searchStationOptions.address1) && vm.searchStationOptions.address1.value !== 'all') {   // 시/도
        searchWord += vm.searchStationOptions.address1.text + ' ';
      }

      if (!this.$_utils.isEmpty(vm.searchStationOptions.address2) && vm.searchStationOptions.address2.value !== 'all') {   // 시/군/구
        searchWord += vm.searchStationOptions.address2.text;
      }

      if (!this.$_utils.isEmpty(searchWord)) {
        // 장소 검색 객체 생성
        const ps = new window.kakao.maps.services.Places();

        ps.keywordSearch(searchWord, (data, status, pagination) => {
          if (status === window.kakao.maps.services.Status.OK) {
            vm.kakaoPage = pagination;
            console.log('kakao', pagination)
            vm.stationResult.kakaoList = data;
          } else if (status === window.kakao.maps.services.Status.ZERO_RESULT) {
            console.log('카카오 검색 결과가 존재하지 않습니다.')
            vm.kakaoPage = pagination;
            vm.stationResult.kakaoList = [];
            vm.isLoading = false;

          } else if (status === window.kakao.maps.services.Status.ERROR) {
            console.log('카카오 검색 결과 중 오류가 발생했습니다.')
          }
        }, { size: 15, });
      }
    },
    searchSideBar(active) {
      document.getElementById('searchSidebar').style.display = active ? 'block' : 'none';
      document.getElementsByClassName('search-box-area')[0].style.display = active ? 'none' : 'block';
    },
    searchRoadFromHere() {
      const vm = this;

      vm.aroundStations = null;
      vm.searchModeChange(false);
      vm.searchSideBar(true);

      if (vm.searchStationSimpleKeyword) {
        vm.searchStationSimpleKeyword = vm.searchStationSimpleKeyword.trim();

        if (vm.searchStationSimpleKeyword.length > 0) {
          this.$nextTick(() => this.$refs.evMapRoad.searchPlace('end','fromHere'));
        }
      }
    },
    searchModeChange(isMode) {
      const vm = this;
      vm.isStationSearchMode = isMode; // true: 충전소 찾기, false: 길 찾기

      if (isMode && this.$refs.evMapRoad) {
        vm.aroundStations = null;

        // Marker 초기화

        vm.removeMarker(vm.stationMarkers);
        vm.stationMarkers = [];

        vm.removePolyline(vm.polylines);   // Remove existing route


        vm.removeRoadMarker('start');
        vm.removeRoadMarker('end');
        vm.removeRoadMarker('road');

        this.$refs.evMapRoad.resetRoad();
      }
      if (!isMode) {
        vm.reset();
      }
    },
    async getStationInfo(id) {
      const vm = this;

      vm.stationResult.stationList = [];
      vm.getEvseInfoDefault(id);
      //vm.getEvseInfoWithUtzPrice(id);

    },
    async getEvseInfoDefault(id) {
      const vm = this;
      vm.isLoading = true;

      const _url = `/me/cp`;

      try {
        const res = await http.get(_url, {
          params: {
            statId: id,
            lat: vm.initMapOptions.lat,
            lon: vm.initMapOptions.lng
          }
        });

        vm.isLoading = false;

        vm.removeMarker(vm.selectMarker);
        // vm.stationResult.stationList = [];
        // vm.stationResult.stationList.push(res.data);

        const tempList = vm.stationResult.stationList[0]
        vm.stationResult.stationList = [{ ...tempList, ...res.data }];
        vm.searchStationOptions.keyword = res.data.statNm;
        vm.searchStationSimpleKeyword = vm.searchStationOptions.keyword;
        vm.stationPage.totalCount = 1;

        vm.$nextTick(() => {
          vm.searchModeChange(true);
          vm.searchSideBar(true);
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getEvseInfoWithUtzPrice(id) {
      const vm = this;
      const _url = `/me/evse/utz`;

      try {
        const res = await http.get(_url, {
          params: {
            statId: id,
            lat: vm.initMapOptions.lat,
            lon: vm.initMapOptions.lng
          }
        });
        const tempList = vm.stationResult.stationList[0]
        vm.stationResult.stationList = [{ ...tempList, ...res.data }];

      } catch(err) {
        console.error(err);
      }
    },
    removeMarker(data) {
      const _data = data;

      if (_data.length > 0) {
        _data.forEach((m) => {
          m.setMap(null);
        });
      }
    },
    onPageChange(val) {
      const vm = this;
      vm.stationPage.currentPage = val;

      if (vm.stationPage.totalCount > 100) {
        vm.getStationItems();
      }
    },
    showOnMap(type, subType, item) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      console.log('type', type)
      console.log('subType', subType)
      console.log('item', item)

      const _lat = type === 'station' ? item.location[1] : (type === 'kakaoResult' ? item.location[1] : item.y);
      const _lng = type === 'station' ? item.location[0] : (type === 'kakaoResult' ? item.location[0] : item.x);

      vm.initMapOptions = {
        lat: _lat,
        lng: _lng,
        level: 4
      }

      // Marker Size
      const iconWidth = 22;
      const iconHeight = 35;
      const imageSize = new window.kakao.maps.Size(iconWidth, iconHeight);

      const coords = {
        shape: 'poly',
        coords: '10,0,5,1,1,5,0,10,0,15,10,34,12,34,22,15,22,7,17,1'
      };

      if (type === 'road') {
        vm.removeRoadMarker(subType);
        let imageSrc = require(`@/assets/images/map/${subType}_point.png`);
        const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, coords);

        if (subType === 'start') {   // 출발지
          vm.searchMarkers.startPoint = new window.kakao.maps.Marker({
            map: vm.mapInstance,
            position: new window.kakao.maps.LatLng(_lat, _lng),
            title: '출발지',
            image: markerImage
          });
        } else {   // 도착지
          vm.searchMarkers.endPoint = new window.kakao.maps.Marker({
            map: vm.mapInstance,
            position: new window.kakao.maps.LatLng(_lat, _lng),
            title: '도착지',
            image: markerImage
          });
        }
      } else {
        if (vm.markerType === 'chargerCount') {
          const imageSrc = require('@/assets/images/map/point.png');
          const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize);

          vm.removeMarker(vm.selectMarker);
          vm.selectMarker = [];

          const marker = new window.kakao.maps.Marker({
            map: vm.mapInstance,
            position: new window.kakao.maps.LatLng(_lat, _lng),
            image: markerImage
          })
          vm.selectMarker.push(marker);
          // console.log('selectMarker ********** point.png',vm.selectMarker)
        }
      }
    },
    showNavi(item) {
      const vm = this;

      if (this.$store.state.layout.browserMode === 'web') {
        const target = item.statNm != '' ? item.statNm : '목적지';
        const targetLat = item.location[1];
        const targetLng = item.location[0];

        if (!this.$_utils.isEmpty(targetLat) && !this.$_utils.isEmpty(targetLng)) {
          window.open(`https://map.kakao.com/link/to/${target},${targetLat},${targetLng}/from/현재위치,${vm.initMapOptions.lat},${vm.initMapOptions.lng}`);
        } else {
          this.$swal('목적지 정보 Error !!', '', 'error');
        }
      } else {
        this.$swal('PC 모드에서 사용 가능합니다.', '', 'info');
      }
    },
    removeRoadMarker(type) {
      const vm = this;

      if (type === 'start' && !this.$_utils.isEmpty(vm.searchMarkers.startPoint)) {
        vm.searchMarkers.startPoint.setMap(null);
      } else if (type === 'end' && !this.$_utils.isEmpty(vm.searchMarkers.endPoint)) {
        vm.searchMarkers.endPoint.setMap(null);
      } else if (type === 'road' && !this.$_utils.isEmpty(vm.aroundMarkers)) {
        vm.aroundMarkers.forEach((m) => {
          m.setMap(null);
        })
        vm.aroundMarkers = [];
      }
    },
    drawRoad(path, searchOptions) {
      const vm = this;
      // const _map = this.$refs.kakaoMap.mapInstance;

      // 경로 주변 충전소 찾기
      vm.getPathAroundStation(path, searchOptions);

      // Marker 초기화
      vm.removeMarker(vm.stationMarkers);
      vm.stationMarkers = [];

      vm.removePolyline(vm.polylines);   // Remove existing route

      vm.mapBounds = new window.kakao.maps.LatLngBounds();
      let linePaths = [];

      path.roads.forEach(item => {
        let tempLinePaths = [];
        for (let i=0; i < (item.vertexes).length; i+=2) {
          let path = new window.kakao.maps.LatLng(item.vertexes[i+1], item.vertexes[i]);
          vm.mapBounds.extend(path);
          tempLinePaths.push(path);
        }
        linePaths.push(tempLinePaths);
      });

      vm.mapInstance.setBounds(vm.mapBounds);   // Set map bounds

      const polylineList = [
        { strokeWeight: 9, strokeColor: '#0576b9', strokeOpacity: 0.9, strokeStyle: 'solid', zIndex: 1 },
        { strokeWeight: 2, strokeColor: '#ffffff', strokeOpacity: 0.9, strokeStyle: 'shortdash', zIndex: 2 }
      ];

      polylineList.forEach(item => {
        let polyline = new window.kakao.maps.Polyline({
          map: vm.mapInstance,
          path: linePaths,   // 선을 구성하는 좌표 배열
          strokeWeight: item.strokeWeight,   // 선 두께
          strokeColor: item.strokeColor,   // 선 색상
          strokeOpacity: item.strokeOpacity,   // 선 불투명도
          strokeStyle: item.strokeStyle,   // 선 스타일
          endArrow: false,   // 종료 지점 화살표 표시 여부
          zIndex: item.zIndex
        });
        vm.polylines.push(polyline);
      });
    },
    getPathAroundStation(path, searchOptions) {
      const vm = this;

      /*let vertexesList = [];
      path.roads.forEach((road, i) => {
        road.vertexes.forEach((item) => {
          vertexesList.push(item);
        })
      });*/

      //let _url = `/onmapi/station/list-by-path`;

      const ticker = vm.markerType === 'chargerCount' ? 1 : 2;
      let _url = `/me/navi`;
      let req_param = {
        roads: path.roads,
        searchOptions: searchOptions,
        ticker: ticker
      }
      console.log('req ', req_param)
      //let req_param = {'vertexes': vertexesList, 'dist': 1.1, 'pageSize': 1000};

      /*this.$axios({
        method: 'post',
        url: _url,
        data: JSON.stringify(req_param),
        headers: {
          "Content-Type" : "application/json; charset=utf-8"
        },
      }).*/

      this.$axios({
        method: 'post',
        url: _url,
        //data: JSON.stringify(path.roads),
        data: JSON.stringify(req_param),
        headers: {
          "Content-Type" : "application/json; charset=utf-8"
        },
        params: {
          ticker: ticker
        }
      }).then((res) => {
        vm.aroundStations = res.data
        console.log('aroundStations', vm.aroundStations)
        vm.stationResult.req = 'road';
        vm.displayMarker();
        //vm.roadDisplayMarker();
      })
    },
    removePolyline(val) {
      if (!this.$_utils.isEmpty(val)) {
        if (Array.isArray(val)) {
          val.forEach(p => {
            p.setMap(null);
          });
        } else {
          val.setMap(null);
        }
      }
    }
  }
}
</script>
